var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-card-code', {
    attrs: {
      "title": "Multiple files"
    },
    scopedSlots: _vm._u([{
      key: "code",
      fn: function fn() {
        return [_vm._v(" " + _vm._s(_vm.codeMultiple) + " ")];
      },
      proxy: true
    }])
  }, [_c('b-card-text', [_c('span', [_vm._v("Multiple file uploading is supported by adding ")]), _c('code', [_vm._v("multiple")]), _c('span', [_vm._v(" prop to component.")])]), _c('b-form-file', {
    attrs: {
      "placeholder": "Choose a file or drop it here...",
      "drop-placeholder": "Drop file here...",
      "multiple": ""
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }